import request from '@/services/interceptor.js'

export const get_storico = (filtri) => {
    return request({
        url: '/storico',
        method: 'get',
        params: filtri || {},
        loadingBar: true
    })
}

export const export_storico_excel = (filtri) => {
    return request({
        url: '/storico/export/excel',
        method: 'get',
        params: filtri || {},
        responseType: 'blob',
        loadingBar: true
    })
}

export const export_storico_pdf = (filtri) => {
    return request({
        url: '/storico/export/pdf',
        method: 'get',
        params: filtri || {},
        responseType: 'blob',
        loadingBar: true
    })
}

// Helper: avvia il download del blob restituito dalle chiamate export_*
export const scaricaBlob = (blob, nomeFile) => {
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = nomeFile
    document.body.appendChild(a)
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
}